import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { FiGlobe } from 'react-icons/fi';

import { LANGUAGES, languagesForRole } from '../../i18n/languages';
import { useAuth } from '../../hooks/useAuth';

const Wrapper = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  color: var(--ve-ink-600);
`;

const Select = styled.select`
  border: 1px solid var(--border-subtle);
  border-radius: 0.25rem;
  padding: 0.3rem 0.5rem;
  font-size: 0.85rem;
  color: var(--ve-ink-800);
  background-color: #ffffff;
  cursor: pointer;

  &:focus {
    outline: none;
    border-color: var(--act-primary);
  }
`;

/**
 * Language selector, scoped to the languages the current role may choose.
 * On auth/public screens (no user) it offers every language.
 * The choice is persisted by i18next's language detector (localStorage).
 */
const LanguageSwitcher = ({ compact = false }) => {
  const { i18n, t } = useTranslation();
  const { currentUser } = useAuth();
  const role = currentUser && currentUser.userType;
  const available = languagesForRole(role);

  // The active language, normalized to the base code (en-US -> en).
  const current = (i18n.resolvedLanguage || i18n.language || 'en').split('-')[0];
  const value = available.includes(current) ? current : 'en';

  const handleChange = (e) => {
    i18n.changeLanguage(e.target.value);
  };

  return (
    <Wrapper title={t('language.label')}>
      {!compact && <FiGlobe size={16} aria-hidden />}
      <Select
        value={value}
        onChange={handleChange}
        aria-label={t('language.select')}
      >
        {available.map((code) => (
          <option key={code} value={code}>
            {LANGUAGES[code] ? LANGUAGES[code].nativeName : code}
          </option>
        ))}
      </Select>
    </Wrapper>
  );
};

export default LanguageSwitcher;
